import React from "react";
import { Modal, Button } from "react-bootstrap";
import { CreditCard } from "react-bootstrap-icons";
import AppStoreGuidance from "./AppStoreGuidance";
import "./manageSubscriptionModal.css";

/**
 * Subscription management surface for App-Store-billed users.
 *
 * variant "app_store": App Store guidance only (the user has no live
 * Stripe subscription — the Stripe billing portal cannot serve them).
 * variant "dual": the user holds live subscriptions with BOTH providers;
 * offer the Stripe portal entry alongside the App Store guidance.
 * `onManageWebBilling` is only used by the "dual" variant and is expected
 * to start the existing customer-portal flow (API call stays in the caller).
 */
const MODAL_TITLE = {
  app_store: "Managed Through Apple",
  dual: "Managed Through Stripe & Apple",
};

export default function ManageSubscriptionModal({
  open,
  onClose,
  variant = "app_store",
  onManageWebBilling,
}) {
  return (
    <Modal
      show={open}
      onHide={onClose}
      centered
      className="manage-subscription-modal-wrapper"
    >
      <Modal.Body className="p-0">
        <div className="manage-subscription-modal">
          <div className="manage-subscription-modal-header">
            <span>{MODAL_TITLE[variant]}</span>
            <button
              className="manage-subscription-modal-close"
              onClick={onClose}
              aria-label="Close"
            >
              &times;
            </button>
          </div>
          <hr className="manage-subscription-modal-divider" />
          <div className="manage-subscription-modal-body">
            {variant === "dual" && (
              <>
                <p className="manage-subscription-modal-intro">
                  You have two active subscriptions.
                </p>
                <div className="manage-subscription-modal-web">
                  <div className="manage-subscription-modal-web-icon">
                    <CreditCard />
                  </div>
                  <p className="manage-subscription-modal-web-text">
                    Manage payment or cancel in Stripe.
                  </p>
                  <Button
                    variant="outline-primary"
                    className="align-self-start mt-3 mb-3"
                    onClick={onManageWebBilling}
                  >
                    Manage in Stripe
                  </Button>
                  <hr className="manage-subscription-modal-divider" />
                </div>
              </>
            )}
            <AppStoreGuidance />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0">
        <Button variant="primary" size="sm" onClick={onClose}>
          Got it
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
